export type EffectiveSource = 'custom' | 'default' | null;

export interface TemplateListItem {
    templateKey: string;
    emailTitle: string | null;
    templateVariables: string[];
    defaultAvailable: boolean;
    isCustomized: boolean;
    isCustomActive: boolean;
    effectiveSource: EffectiveSource;
    emailSubject: string;
    updatedAt: string;
}

export interface DefaultTemplateContent {
    emailSubject: string;
    htmlBody: string;
    textBody: string | null;
    updatedAt: string;
    designJson?: string | null;
}

export interface CustomTemplateContent {
    id: number;
    emailSubject: string;
    htmlBody: string;
    textBody: string | null;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    designJson?: string | null;
}

export interface TemplateDetail {
    templateKey: string;
    emailTitle: string | null;
    templateVariables: string[];
    defaultAvailable: boolean;
    default: DefaultTemplateContent | null;
    custom: CustomTemplateContent | null;
    effectiveSource: EffectiveSource;
}

export interface SaveRequest {
    templateKey: string;
    emailSubject?: string;
    htmlBody?: string;
    textBody?: string;
    isActive?: boolean;
    designJson?: string;
}

/** Server envelope: every reply is HTTP 200 with the real status in the body. */
export interface ApiEnvelope<T> {
    status: number;
    message: string;
    data: T;
}

export class EmailTemplateApiError extends Error {
    constructor(public status: number, message: string) {
        super(message);
        this.name = 'EmailTemplateApiError';
    }
}

// Limits enforced by the server, checked in the browser first.
export const SUBJECT_MAX_LENGTH = 500;
export const HTML_MAX_LENGTH = 1000000;
export const TEXT_MAX_LENGTH = 500000;
